import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from './MyDialog.vue';
let ConfirmDelete = class ConfirmDelete extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
    handleDelete() {
        this.$emit('delete');
        this.isOpen = false;
    }
};
__decorate([
    Prop(String)
], ConfirmDelete.prototype, "label", void 0);
__decorate([
    Prop(String)
], ConfirmDelete.prototype, "item", void 0);
ConfirmDelete = __decorate([
    Component({
        components: {
            MyDialog
        }
    })
], ConfirmDelete);
export default ConfirmDelete;
